import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import { feesResponseFetch, feesResponsePost } from "../../../api/FeesDeposite";
import { closeModal, ToastMain ,SweetAlertShow} from "../../master/Master";



const FeeFollowUpResponse = () => {
    const [filter, setFilter] = useState("");

    const [data, setData] = useState([]);
    const [modalData, setModalData] = useState('')
    const [name, setName] = useState('');
    const [date, setDate] = useState();
    const [endDate, setEndDate] = useState('')
    const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0])
    const [followData, setFollowData] = useState([]);
    const [id, setId] = useState('');
    const [loading, setLoading] = useState(false);



    const FetchResponse = async () => {
        let addUrl = `&search=${name}&start_date=${startDate}&end_date=${endDate}&type=${'fees'}`
        try {
            const response = await feesResponseFetch(addUrl);

            if (response.data.status) {
                setData(response.data.data?.data || []); // ✅ setting the correct array
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'Something went wrong',
                // });
                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.message || 'Something went wrong',
            // });

            SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.message)
        }
    };


    const handelFolloup = async (e) => {
        e.preventDefault();
        setLoading(true); // ⬅️ Start loader

        try {
            const formData = new FormData(e.target);
            const response = await feesResponsePost(formData);

            if (response?.data?.status) {
                ToastMain.fire({
                    icon: "success",
                    title: "Create Successfully!",
                })
                closeModal("feefollowup")
                e.target.reset();
            } else {
                // ToastMain.fire({
                //     icon: "info",
                //     title: "Something Went Wrong!",
                // })

                SweetAlertShow('info','Warning',response?.data?.message )
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: "error",
            //     title: error?.response?.data?.message || error?.response?.message || "Something Went Wrong!",
            // })

            SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.response?.message ?? error?.message)
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (startDate) {
            FetchResponse()
        }

    }, [name, startDate, endDate])
return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid py-4">
                                <div className="card shadow-sm p-3 mb-4">
                                    <div className="d-flex flex-wrap gap-3">
                                        <Link to="/fees/collection" className="btn btn-outline-primary btn-sm ">
                                            <i className="bi bi-cash-stack me-2"></i> Fee Deposit
                                        </Link>
                                        <Link to="/followup_response" className="btn btn-primary btn-sm">
                                            Fees Follow up
                                        </Link>
                                    </div>
                                </div>
                                <div className="card shadow border-0 mb-2 mt-2">
                                    <div className="card-body">

                                        <div className="row g-3 mb-4">
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <h4 className="fw-bold text-primary mb-0">

                                                    Fees Follow up
                                                </h4>
                                            </div>
                                            <div className="col-md-3 form-floating form-floating-outline">
                                                <input
                                                    type="text"
                                                    placeholder="Search "
                                                    className="form-control"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                                <label>Search</label>
                                            </div>

                                            <div className="col-md-3 form-floating form-floating-outline">
                                                <input
                                                    type="Date"
                                                    placeholder="Date "
                                                    className="form-control"
                                                    value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                />
                                                <label>Start Date</label>
                                            </div>
                                            <div className="col-md-3 form-floating form-floating-outline">
                                                <input
                                                    type="Date"
                                                    placeholder="Date "
                                                    className="form-control"
                                                    value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                />
                                                <label> End Date</label>
                                            </div>
                                            <div className="col-md-3 form-floating form-floating-outline">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => {
                                                         setStartDate(new Date().toISOString().split("T")[0]); // clear range if needed
                                                        setEndDate("");
                                                        
                                                    }}
                                                >
                                                    Today
                                                </button>

                                            </div>

                                        </div>

                                    </div>
                                </div>


                                <div className="card shadow border-0">
                                    <div className="card-body">
                                        {/* Header */}


                                        {/* Filter/Search */}


                                        {/* Table */}
                                        <div className="table-responsive">
                                            <table className="table table-hover">
                                                <thead className="">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Student Name</th>
                                                        <th>Mobile</th>
                                                        <th>Follow-Up Date</th>

                                                        <th>Type</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.length > 0 ? (
                                                        data.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td className="fw-semibold">{item.course_and_fees?.student_info?.name || "N/A"}</td>
                                                                <td>{item.course_and_fees?.student_info?.phone || "N/A"}</td>
                                                                <td>
                                                                    <span className="badge bg-info-subtle text-dark">
                                                                        {item?.next_followup_date || "N/A"}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <span
                                                                        className={`badge px-3 py-2 rounded-pill ${item.fee_status === "1"
                                                                            ? "bg-success"
                                                                            : "bg-warning text-dark"
                                                                            }`}
                                                                    >
                                                                        {item.type}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-label-danger d-flex align-items-center gap-1"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#feefollowup"
                                                                        onClick={() => {
                                                                            setModalData(item);
                                                                            setId(item.id)
                                                                            console.log('modale data', item)
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-telephone "></i>{" "}
                                                                        {/* FollowUp */}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center text-muted">
                                                                No follow-up responses found.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>


                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {/* End card */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="feefollowup"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <form onSubmit={handelFolloup}>
                            <div className="modal-header bg-label-primary py-3">
                                <h1 className="modal-title fs-5">Follow Up Response</h1>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                {/* 🔽 Scrollable Previous Responses Table */}
                                <div className="col-md-12 mb-12">
                                    <div className="">
                                        <h5 className="card-header pb-6">Follow up Timeline</h5>
                                        <div
                                            className="card-body"
                                            style={{
                                                maxHeight: '250px',
                                                overflowY: 'auto',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '6px',
                                                padding: '1rem'
                                            }}
                                        >
                                            <ul className="timeline mb-0">
                                                {modalData?.id ? (
                                                    <li
                                                        key={modalData.id}
                                                        className="timeline-item timeline-item-transparent"
                                                    >
                                                        <span className="timeline-point timeline-point-primary"></span>
                                                        <div className="timeline-event">
                                                            <div className="timeline-header mb-2">
                                                                <h6 className="mb-0">Follow-up #{modalData?.id}</h6>
                                                                <small className="text-muted">
                                                                    {modalData.date || "—"}
                                                                </small>
                                                            </div>
                                                            <p className="mb-2">
                                                                <strong>Response:</strong> {modalData.response || "—"}
                                                            </p>
                                                            <p className="mb-0">
                                                                <strong>Next Follow-Up:</strong>{" "}
                                                                {modalData.next_followup_date || "—"}
                                                            </p>
                                                        </div>
                                                    </li>
                                                ) : (
                                                    <li className="timeline-item timeline-item-transparent">
                                                        <span className="timeline-point timeline-point-secondary"></span>
                                                        <div className="timeline-event">
                                                            <div className="timeline-header mb-2">
                                                                <h6 className="mb-0">No follow-ups yet</h6>
                                                            </div>
                                                            <p className="mb-0">This student has no recorded responses.</p>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>

                                        </div>
                                    </div>
                                </div>



                                <input
                                    type="hidden"
                                    value={modalData.course_and_fees?.student_info?.id}
                                    name="user_id"
                                />


                                <div className="row mt-5">
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            defaultValue={modalData.course_and_fees?.student_info?.name}
                                            id="studentName"
                                            placeholder="Enter Name"
                                            readOnly
                                        />
                                        <label htmlFor="studentName" className="fw-semibold">
                                            Name
                                        </label>
                                    </div>
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <select name="type" className="form-control">
                                            <option value="fees">Fees</option>
                                        </select>
                                        <label>Type</label>
                                    </div>
                                    <div className="form-floating col-md-4 form-floating-outline mb-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="amount"

                                            id=""
                                            placeholder="Amount"

                                        />
                                        <label htmlFor="studentName" className="fw-semibold">
                                            Amount
                                        </label>
                                    </div>

                                    {/* Follow-Up Dates */}
                                    <div className="form-floating col-md-6 form-floating-outline mb-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            id="followupDate"
                                            defaultValue={new Date().toISOString().split("T")[0]}
                                            placeholder="Follow-Up Date"
                                            required
                                            readOnly
                                        />
                                        <label htmlFor="followupDate" className="fw-semibold">
                                            Follow-Up Date
                                        </label>
                                    </div>
                                    <div className="form-floating col-md-6 form-floating-outline mb-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="next_followup_date"
                                            id="nextFollowupDate"
                                            placeholder="Next Follow-Up Date"
                                            defaultValue={
                                                new Date(Date.now() + 86400000)
                                                    .toISOString()
                                                    .split("T")[0]
                                            } // 👈 tomorrow's date
                                            min={new Date().toISOString().split("T")[0]} // 👈 block past dates
                                            required
                                        />
                                        <label htmlFor="nextFollowupDate" className="fw-semibold">
                                            Next Follow-Up Date
                                        </label>
                                    </div>

                                    {/* Response Textarea */}
                                    <div className="form-floating form-floating-outline mb-4">
                                        <textarea
                                            type="text"
                                            className="form-control input-uppercase"
                                            name="response"
                                            id="remark"
                                            style={{ height: "100px" }}
                                            placeholder="e.g., Will pay next week, not picking up..."
                                            required
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                e.target.value = value
                                                    .split(" ")
                                                    .map(
                                                        (word) =>
                                                            word.charAt(0).toUpperCase() +
                                                            word.slice(1).toLowerCase()
                                                    )
                                                    .join(" ");
                                            }}
                                        ></textarea>
                                        <label htmlFor="remark" className="fw-semibold">
                                            Response
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* 🔽 Footer Buttons */}
                            <div className="modal-footer bg-label-primary py-3">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FeeFollowUpResponse;
